import { useEffect } from 'react';

export default function useKeyboardInsets(selector = 'input, textarea') {
  useEffect(() => {
    const handler = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target && 'scrollIntoView' in target) {
        setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
      }
    };

    const elements = Array.from(document.querySelectorAll(selector));
    elements.forEach(el => el.addEventListener('focus', handler));
    return () => {
      elements.forEach(el => el.removeEventListener('focus', handler));
    };
  }, [selector]);
}
